import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();
export const facialValidationState = atom<boolean>({
  key: 'facialVerificationState',
  default: true,
  effects_UNSTABLE: [persistAtom],
});
